import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesRoutes,
  resourcesGeofence,
  resourcesSalidas,
  resourcesOperators,
  resourcesUnits,
  resourcesBranch,
  getNextTimeSalida,
} from "../../helpers/backend_helper";
import { getStorageCompany } from "../../helpers/api_helper";
import { Alert, ToastHelper } from "../../helpers/alerts/alertHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import NibbleInput from "../../components/Fields/NibbleInput";
//import { createFilter } from "react-select/dist/react-select.cjs.prod";


const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
  catalogs,
}) => {
  const company = getStorageCompany();
  const [errors, setErrors] = useState([]);
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    route_id: authUser.route_id,
    select: true,
  });
  let params = { params: filters };
  const [selects, setSelects] = useState({
    ramales: [],
    operadores: [],
    routes: [],
    units: [],
    timers: [
      { name: "Tiempo 1", id: 1 },
      { name: "Tiempo 2", id: 2 },
      { name: "Tiempo 3", id: 3 },
      { name: "Tiempo 4", id: 4 },
      { name: "Tiempo 5", id: 5 },
      { name: "Tiempo 6", id: 6 },
      { name: "Tiempo 7", id: 7 },
      { name: "Tiempo 8", id: 8 },
      { name: "Tiempo 9", id: 9 },
    ],
  });
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  useEffect(() => {
    setSelects({ ...selects, ...catalogs });
  }, [catalogs]);

  /*
  useEffect(() => {
    getSelects();
  }, [filters]);
  */

  const getSelects = async () => {
    const ramales = await resourcesBranch("get", params);
    if (authUser.profile_id == 2) {
      const routes = await resourcesRoutes("get", {});
      setSelects({ ...selects, routes: routes.data });
    }
    if (!filters.route_id) {
      if (!item.ruta_id || authUser.profile_id == 2) {
        const routes = await resourcesRoutes("get", {});
        setSelects({ ...selects, ramales: ramales.data, routes: routes.data });
      } else {
        setSelects({ ...selects, ramales: ramales.data });
      }
    } else {
      const operators = await resourcesOperators("get", params);
      const units = await resourcesUnits("get", params);
      setSelects({
        ...selects,
        operadores: operators.data,
        units: units.data,
        ramales: ramales.data,
      });
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: item,
    validationSchema: Yup.object({
      ramal_id: Yup.number().nullable().required("Requerido"),
      timer: Yup.string().nullable().required("Requerido"),
      type: Yup.string().nullable().required("Requerido"),
      date: Yup.string().nullable().required("Requerido"),
      time: Yup.string().nullable().required("Requerido"),
      operator_id: Yup.number().nullable(),
      unit_id: Yup.number().nullable().required("Requerido"),
      destination: Yup.string().nullable().required("Requerido"),
      route_id: Yup.number().nullable().required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  useEffect(() => {
    if (validation.values.unit_id && validation.values.operator_id == null) {
      const operator = selects.operadores.filter((e) => {
        return e.unit_id == validation.values.unit_id;
      });
      validation.setFieldValue("operator_id", operator?.[0]?.id ?? null, true);
    }
  }, [validation?.values?.unit_id]);

  const save = async (data) => {
    setLoading(true);
    const response = modal.update
      ? await resourcesSalidas("put", data, data.id)
      : await resourcesSalidas("post", data);
    responseAction(response);
  };

  useEffect(() => {
    if (selects.ramales) {
      const ramal = selects.ramales.find((e) => {
        return e.id == validation.values.ramal_id;
      });
      validation.setFieldValue(
        "destination",
        ramal?.name ?? item.destination,
        true
      );
    }

    const getTime = async () => {
      const response = await getNextTimeSalida(validation.values.ramal_id);
      validation.setFieldValue("time", response.time, true);
    };

    if (validation.values.ramal_id && !modal.update) getTime();
  }, [validation.values.ramal_id]);

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.salida;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [newItem, ...items];
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  const ramal = selects.ramales.find(
    (ramal) => ramal.id === validation.values.ramal_id
  );
  const ramalUnits = ramal ? ramal.units : [];

  const filteredUnits = ramalUnits?.length ? ramalUnits : selects.units;

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar Salida" : "Nueva Salida"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="d-none" style={{ wordWrap: "break-word" }}>
              {JSON.stringify(validation.values)}
            </div>
            <div className="row">
              {authUser.profile_id == 2 && (
                <NibbleInput
                  md={6}
                  label="Ruta:"
                  fieldName="route_id"
                  fieldType="select"
                  selectItems={selects.routes}
                  validation={validation}
                />
              )}
              <NibbleInput
                md={6}
                label="Ramal:"
                fieldName="ramal_id"
                fieldType="select"
                selectItems={selects.ramales}
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="¿Qué tiempo?:"
                fieldName="timer"
                fieldType="select"
                selectItems={selects.timers}
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Tipo de salida:"
                fieldName="type"
                fieldType="select"
                selectItems={[
                  { name: "Completa", id: 1 },
                  { name: "Solo Ida", id: 2 },
                  { name: "Solo Regreso", id: 3 },
                ]}
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Unidad / Camión:"
                fieldName="unit_id"
                fieldType="select"
                /* selectItems={selects.units} */
                selectItems={filteredUnits}
                validation={validation}
                selectOptionLabel={(option) => `${option.number}`}
              />

              <NibbleInput
                md={6}
                label="Fecha:"
                fieldName="date"
                fieldType="date"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Hora:"
                fieldName="time"
                fieldType="time"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Operador:"
                fieldName="operator_id"
                fieldType="select"
                selectItems={selects.operadores}
                validation={validation}
                selectOptionLabel={(option) =>
                  `${option.full_name} - unidad ${option.unit?.number}`
                }
              />

              <NibbleInput
                md={6}
                label="Destino:"
                fieldName="destination"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Ticket adulto inicial:"
                fieldName="start_ticket"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Ticket adulto final:"
                fieldName="end_ticket"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Ticket menores inicial:"
                fieldName="start_ticket_menor"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Ticket menores final:"
                fieldName="end_ticket_menor"
                fieldType="number"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              {" "}
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
